import { getEnvName } from "@callcenter/helpers"

const stagingConfig = {
  apiKey: "AIzaSyAJdb-PStN0yOlIhHI6SHiDJ3YS7v7mTI0",
  authDomain: "voiso-softphone-stg.firebaseapp.com",
  projectId: "voiso-softphone-stg",
  storageBucket: "voiso-softphone-stg.firebasestorage.app",
  messagingSenderId: "901620501753",
  appId: "1:901620501753:web:399af3aa5610fe8ade2628",
  measurementId: "G-0D4QK7441F"
}

const productionConfig = {
  apiKey: "AIzaSyCVY8s9PUHwD8f8UpjuvfKp3GIsh9rrLV0",
  authDomain: "voiso-production.firebaseapp.com",
  projectId: "voiso-production",
  storageBucket: "voiso-production.firebasestorage.app",
  messagingSenderId: "536260651864",
  appId: "1:536260651864:web:e7b2835a51bb82ebee532d"
}

export const getFirebaseConfig = () => {
  const env = getEnvName(window.location.hostname)

  return env === "production" ? productionConfig : stagingConfig
}
